import React from 'react'
import Sidebar from '../components/Sidebar/Sidebar';
import Topbar from '../components/Topbar';
import Layout from '../layout/Layout';
import { Navigate, Route, Routes } from 'react-router-dom';
import '../styles/variables.css';
import DashboardHome from './DashboardHome';
import FieldUpdate from '../pages/FieldUpdate/FieldUpdate';
import DocumentUpdate from '../pages/DocumentUpdate/DocumentUpdate';
import VideoUpdate from '../pages/VideoUpdate/VideoUpdate';
import PhotoUpdate from '../pages/PhotoUpdate/PhotoUpdate';
import CreateTask from '../pages/CreateTask/CreateTask';
import AudioUpdate from '../pages/AudioUpdate/AudioUpdate';
import SubTaskScreen from '../components/SubTaskScreen/SubTaskScreen';
import SubtaskVerification from '../pages/SubtaskVerification/SubtaskVerification';
import RecentUpdates from '../pages/RecentUpdates/RecentUpdates';

const Dashboard = () => {
return (
    // .App (index.css) sets an explicit height: 100% so its children can chain
    // percentage heights down to Layout.jsx's .applicationsDashboardContainer
    // (and from there to the sidebar's own height: 100%). This div is a real,
    // genuinely-rendered DOM node sitting directly inside .App - other routes
    // reach their dashboard's root div with no DOM element in between (Routes/
    // Route/ProtectedRoutes/ErrorBoundary render no wrapper of their own), so
    // .App's height reaches them untouched. Here it had no height set, which
    // defaults to auto/shrink-to-fit - breaking the chain one level before
    // Layout.jsx even renders, so the fix there alone couldn't take effect.
    <div style={{ height: '100%' }}>
        <Routes>
        {/* This wraps all dashboard routes with the Layout */}
        <Route element={<Layout />}>
            <Route index element={<DashboardHome />} />
            {/* <Route index element={<Navigate to="dashboard" />} /> */}
            <Route path="dashboard" element={<DashboardHome />} />
            {/* <Route path="all-task" element={<p>All task</p>} />
            <Route path="today-task" element={<p>Today’s Task</p>} /> */}
            {/* <Route path="new-task" element={<CreateTask />} />
            <Route path="field-update" element={<FieldUpdate />} />
            <Route path="document-update" element={<DocumentUpdate />} />
            <Route path="video-update" element={<VideoUpdate />} />
            <Route path="photo-update" element={<PhotoUpdate />} />
            <Route path="audio-update" element={<AudioUpdate />} /> */}
            <Route path=":taskId/:subtaskTypeId/create-subtask" element={<SubTaskScreen />} />
            {/* <Route path=":taskId/subtask-verification" element={<SubtaskVerification />} /> */}
            <Route path=":taskId/subtask-verification/:activeTab" element={<SubtaskVerification />} />
            <Route path="settings" element={<p>Settings</p>} />
            <Route path="recent-updates" element={<RecentUpdates />} />
        </Route>
        </Routes>
    </div>
  );
}

export default Dashboard